import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { UploadVideoParams } from '@/shared/api/requests/video/upload/request';
import { uploadVideo } from '@/shared/api/requests/video/upload/request';

export const useUploadVideoMutation = (
  settings?: MutationSettings<UploadVideoParams, typeof uploadVideo>
) =>
  useMutation({
    mutationKey: ['uploadVideo'],
    mutationFn: ({ params, config }) =>
      uploadVideo({
        params,
        config
      }),
    ...settings?.options
  });
